import React from 'react';
import Highcharts, { SeriesOptionsType } from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import classNames from 'classnames';
import { withErrorBoundary } from '../errors';
import { FormattedMessage } from '@/utils/i18n';

export type LineChartDatum = SeriesOptionsType;
export type LineChartOptions = Highcharts.Options;

type Props = {
  data: LineChartDatum[];
  chartOptions: LineChartOptions;
  dark?: boolean;
  className?: string;
  emptyStateText?: string;
};

const LineChart: React.FC<Props> = ({ data, chartOptions, dark, className, emptyStateText }) => {
  const hasData = data && data.length > 0;
  const options = { ...chartOptions, chart: { ...chartOptions.chart } };

  return (
    <div className={classNames('area-chart', { dark }, className)}>
      <div className="graph-container">
        {hasData ? (
          <HighchartsReact highcharts={Highcharts} options={{ ...options, series: data }} constructorType="stockChart" />
        ) : (
          <div className={classNames('empty-chart flex-fill', { 'is-light': !dark })}>
            {emptyStateText !== undefined && <span>{emptyStateText}</span>}
            {emptyStateText === undefined && <FormattedMessage id="Charts.EmptyPeriod" />}
          </div>
        )}
      </div>
    </div>
  );
};

export default withErrorBoundary(LineChart);
